<template>
    <div>
        <breadCrumb 
            :icon="'fa-users'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_setup`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <h1 class="h5">{{$t('setup.header')}}</h1>
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 pb-4">
                    <div class="row">
                        <div class="col-sm-12 col-md-4"> 
                            <div class="form-group d-flex">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0" :style="selectedTab != 1 ? 'opacity: 0.6' : {}">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet" :disabled="selectedTab != 1">
                                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content p-5">
                        <ul class="nav nav-pills nav-justified" role="tablist">
                            <li v-for="tab in $i18n.messages[$i18n.locale].tab.setupTabs" :key="tab.id" class="nav-item">
                                <a :class="{'active': selectedTab == tab.id}" class="nav-link border-bottom border-bottom-left-radius-0 border-bottom-right-radius-0">{{tab.id}}. {{tab.text}}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div v-if="!isSpinnerShow && results.length != 0" class="tab-content mt-5">
                            <setupInfo v-if="Object.keys(selectedOutlet).length != 0" class="tab-pane" :class="{'active': selectedTab == 1}" :outletID="parseInt(selectedOutlet.id)" :location="results.location"  @submitInfo="nextStep"></setupInfo>
                            <setupStaff ref="setupStaff" class="tab-pane" :class="{'active': selectedTab == 2}" :outletID="parseInt(selectedOutlet.id)" @returnPreviousStep="previousStep" @submitStaff="nextStep"></setupStaff>
                            <setupService class="tab-pane" :class="{'active': selectedTab == 3}" @returnPreviousStep="previousStep" @submitService="nextStep"></setupService>
                            <setupImage class="tab-pane" :class="{'active': selectedTab == 4}" :slider="results.slider" :outletID="parseInt(selectedOutlet.id)" @returnPreviousStep="previousStep" @submitSlider="nextStep"></setupImage>
                            <setupGallery class="tab-pane" :class="{'active': selectedTab == 5}" :gallery="results.gallery" :outletID="parseInt(selectedOutlet.id)" @returnPreviousStep="previousStep" @submitGallery="nextStep"></setupGallery>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'

import SetupInfo from './Setup_Info'
import SetupStaff from './Setup_Staff'
import SetupService from './Setup_Service'
import SetupImage from './Setup_Image'
import SetupGallery from './Setup_Gallery'

export default {
    name: 'setup',
    components:{
        SetupInfo, SetupStaff, SetupService, SetupImage, SetupGallery, BreadCrumb
    },
    data(){
        return{
            selectedTab: 1,
            outlet: [], selectedOutlet: {},
            results: [],
            isSpinnerShow: false,
        }
    },
    methods:{
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.getInfo();
        },
        closeModal(isError){
            if(!isError){
                this.selectedTab = 1;
                this.getInfo();
            }
            this.$parent.isModalShow = false;
        },
        getInfo(){
            let $vm = this;
            $vm.results = [];
            const QUERY_STRING = "/" + $vm.selectedOutlet.id + $vm.$api.INFO;
            const url =  this.$api.OUTLET + QUERY_STRING;

            this.isSpinnerShow = true
            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.results = response.data;
                $vm.isSpinnerShow = false
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
        },
        nextStep(step){
            this.selectedTab = step < 5 ? step + 1 : 5;            
            if(step == 5){
                this.$parent.setModal(this, false, true, this.$i18n.t('subMenu.my_salon_setup') + this.$i18n.t('message.success.update'));
            }
        },
        previousStep(step){
            this.selectedTab = step - 1;
            if(step == 3){
                this.$refs.setupStaff.getStaffItems()
            }
        },
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.getInfo();  
    }
}
</script>
<style scoped>
.show{
    display: block;
}
</style>